import { SagaIterator } from 'redux-saga';
import { fork, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleEditFlow } from '../../../../flow/sagas/EditFlowSaga';
import { handleEnterFlowSubspace } from '../../../../flow/sagas/EnterFlowSpaceSaga';
import { handleRunFlow } from '../../../../flow/sagas/RunFlowSaga';
import { rootHomeSaga } from '../../../../home/sagas/HomeSaga';
import { handleEditPublishedConnection } from '../../../../publishedConnection/sagas/EditPublishedConnectionSaga';
import {
  AddFieldToSortOrder,
  ContentCountsRequest,
  Download,
  EditFlow,
  EditPublishedConnection,
  EditView,
  EncryptContent,
  EnterFlowSubspace,
  ExtractContent,
  GetContentDetail,
  LaunchRevisionHistory,
  MoveContents,
  NewFlowForDatasource,
  RenameContent,
  RunFlow,
  SelectSortOrder,
  ShareContent,
  SortContent,
  WhoHasSeenThisView,
  DeleteFlowDraft,
} from '../../../actions/AppActionTypes';
import { handleNewFlowForDatasourceAction } from '../NewFlowForDatasourceSagas';
import { handleContentCountsRequest } from './ContentCountsSagas';
import { processGetContentDetailAction } from './ContentDetailSagas';
import { processDownload } from './download/DownloadSagas';
import { handleEditViewAction } from './EditViewSaga';
import { processEncryptContentAction } from './EncryptContentSaga';
import { processExtractContentAction } from './ExtractContentSaga';
import { rootFavoritesSaga } from './FavoritesSagas';
import { rootHiddenRecsSaga } from '../../../../recommendations/sagas/HideRecommendationSagas';
import { rootMixedContentSaga } from './MixedContentSagas';
import { handleMoveContentAction } from './MoveContentSaga';
import { handleRenameContent } from './RenameContentSagas';
import { handleRevisionHistoryAction } from '../../../../revisionHistory/sagas/RevisionHistorySaga';
import { handleShareContentAction } from './ShareContentSaga';
import { processAddFieldToSortOrder, processSelectSortOrder, processSortContent } from './SortContentSagas';
import { rootSubscriptionSagas } from './SubscriptionSagas';
import { handleWhoHasSeenThisViewAction } from './WhoHasSeenThisViewSagas';
import { handleDeleteFlowDraft } from '../../../../flow/sagas/DeleteFlowDraftSaga';

export function* rootContentSaga(): SagaIterator {
  yield takeEvery(Download, processDownload);
  yield takeEvery(MoveContents, handleMoveContentAction);
  yield takeEvery(RenameContent, handleRenameContent);
  yield takeEvery(NewFlowForDatasource, handleNewFlowForDatasourceAction);
  yield takeEvery(RunFlow, handleRunFlow);
  yield takeEvery(EditFlow, handleEditFlow);
  yield takeEvery(DeleteFlowDraft, handleDeleteFlowDraft);
  yield takeEvery(EditPublishedConnection, handleEditPublishedConnection);
  yield takeLatest(EnterFlowSubspace, handleEnterFlowSubspace);
  yield takeLatest(SelectSortOrder, processSelectSortOrder);
  yield takeLatest(SortContent, processSortContent);
  yield takeLatest(AddFieldToSortOrder, processAddFieldToSortOrder);
  yield takeLatest(ContentCountsRequest, handleContentCountsRequest);
  yield takeEvery(LaunchRevisionHistory, handleRevisionHistoryAction);
  yield takeEvery(GetContentDetail, processGetContentDetailAction);
  yield takeLatest(WhoHasSeenThisView, handleWhoHasSeenThisViewAction);
  yield takeLatest(EditView, handleEditViewAction);
  yield takeLatest(ShareContent, handleShareContentAction);
  yield takeEvery(EncryptContent, processEncryptContentAction);
  yield takeEvery(ExtractContent, processExtractContentAction);
  yield fork(rootMixedContentSaga);
  yield fork(rootFavoritesSaga);
  yield fork(rootHiddenRecsSaga);
  yield fork(rootSubscriptionSagas);
  yield fork(rootHomeSaga);
}
